import React, { Component } from "react";

// Router
import { withRouter } from "react-router-dom";

// SCSS
import "./ShoveBerryLevel.scss";

//Components
import ShoveberryLevelLayoutHeader from "components/Shoveberry/ShoveberryLevelLayoutHeader";
import ShoveberryLevelLayoutActionsPanel from "components/Shoveberry/ShoveberryLevelLayoutActionsPanel";
import ShoveberryLevelGrid from "components/Shoveberry/ShoveberryLevelGrid";
import ShoveberryLevelLayoutLevelsList from "components/Shoveberry/ShoveberryLevelLayoutLevelsList";
import ShoveberryLevelsLayoutControlPanelResponsive from "components/Shoveberry/ShoveberryLevelsLayoutControlPanelResponsive";
import ShoveberryModal from "components/Shoveberry/ShoveberryModal";
import Header from "components/Shoveberry/header";
import { sendResult } from "utils/helper";

// Constants
import { SHOVEBERRY_LEVELS_DATA } from "utils/constants";

// Music
import PlayMusic from "static/assets/shoveberry/sounds/game-play.mp3";
import { storage } from "services/config/storage";
import { GC } from "services/config/gamecentreService";

class ShoveBerryLevel extends Component {
  gridComponent = React.createRef();

  state = {
    showModal: false,
    showLevelModal: false,
    isMobileView: false,
    modalData: {
      overlayColor: "#ff6262",
      thumbnail: "",
      title: "Oops!",
      timeTaken: "4:30",
      totalMoves: "30",
      subTitle: "You did better than 43% players",
      showPlayAgain: true,
      actionButtonText: "EXPLORE MORE GAMES",
      actionButtonRedirect: "/",
      showTimeSection: true,
    },
    levelBasedScores: [],
    currentLevel: 1,
    muteAudio: true,
    timer: 0,
    totalTime: 0,
  };
  audio = new Audio(PlayMusic);

  // TODO: Fix error in the layout for levels 5, 7 & 9

  startCounting() {
    setInterval(this.countUp, 1000);
  }

  countUp = () => {
    this.setState(({ timer, totalTime }) => ({
      timer: timer + 1,
      totalTime: totalTime + 1,
    }));
  };

  componentDidMount() {
    if (window && window.innerWidth < 1023) {
      this.setState({
        isMobileView: true,
      });
    }

    const gameData = storage.get.levelData();
    if (!gameData?.levelData?.length) GC.createGameMasterSession();
    if (gameData?.levelData?.length === 4) {
      this.setState({
        currentLevel: 4,
      });
      this.showSuccessModal();
    } else if (gameData?.levelData?.length) {
      this.setState({
        currentLevel: gameData.levelData.length + 1,
      });
    }

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
    //for music
    this.audio.volume = 0;
    this.audio.play();
    this.audio.addEventListener("ended", function () {
      this.play();
    });
    this.startCounting();
  }

  getMainContainerHeight() {
    if (!this.state.isMobileView) {
      return "calc(100vh - 65px)";
    } else {
      let controlPanel = document.querySelector(
        ".shoveberry-level-layout__control-panel-container"
      );
      let controlPanelHeight = controlPanel ? controlPanel.clientHeight : 0;
      return `calc(100vh - ${controlPanelHeight + 65}px)`;
    }
  }

  componentWillUnmount() {
    this.audio.removeEventListener("ended", () => {
      this.setState({ play: false });
      this.audio.pause();
    });
  }

  showTimeOutModal() {
    console.log(this.state.currentLevel);
    const timerMinutes = Math.floor(storage.get.timeRemaining() / 60);
    const timerSeconds = Math.floor(storage.get.timeRemaining() % 60);
    const finalObj = {
      gameData: {
        levelData: [
          {
            level: this.state.currentLevel,
            isLevelCleared: false,
            totalTime: this.state.timer,
            timeForFirstMove: localStorage.getItem("firstMove"),
            totalMoves: localStorage.getItem("moves"),
            optimalMoves:
              SHOVEBERRY_LEVELS_DATA[this.state.currentLevel].optimalMoves,
            averageTimeForMove: (
              localStorage.getItem("moves") / this.state.timer
            ).toFixed(2),
            noOfUndo: localStorage.getItem("undos"),
            noOfResets: localStorage.getItem("reset"),
          },
        ],
      },
    };
    console.log(finalObj);
    if (timerMinutes && timerSeconds) {
      sendResult(finalObj);
    } else console.log("Time already up!");
    // sendResult(finalObj);
    this.setState({
      showModal: true,
      modalData: {
        overlayColor: "rgba(0, 0, 0, 0.3)",
        title: "Oops!",
        timeTaken: "6",
        totalMoves: this.state.currentLevel - 1,
        subTitle: "You did great",
        showPlayAgain: true,
        actionButtonText: "NEXT GAME",
        onSubmit: this.goToNextGame,
        thumbnail: this.getSuccessModalThumbnail(
          SHOVEBERRY_LEVELS_DATA.length - 1
        ),
        // actionButtonRedirect: "/shoveberry",
        showTimeSection: true,
        // onPlayAgainClicked: this.replayLevelMethod(),
      },
    });
  }

  showSuccessModal() {
    this.setState({
      showModal: true,
      modalData: {
        overlayColor: "rgba(0, 0, 0, 0.3)",
        showTimeSection: false,
        showPlayAgain: false,
        actionButtonText:
          this.state.currentLevel === SHOVEBERRY_LEVELS_DATA.length - 1
            ? "Continue"
            : `Start Level ${this.state.currentLevel + 1} ->`,
        title: "Awesome",
        subTitle:
          this.state.currentLevel === SHOVEBERRY_LEVELS_DATA.length - 1
            ? "You can proceed to the next game"
            : "You can proceed to the next round",
        thumbnail: this.getSuccessModalThumbnail(this.state.currentLevel),
        // actionButtonRedirect: `/level${this.state.currentLevel}`,
        onSubmit: this.goToNextLevel,
      },
    });
  }

  goToNextLevel = () => {
    if (this.state.currentLevel < SHOVEBERRY_LEVELS_DATA.length - 1) {
      this.setState({
        currentLevel: this.state.currentLevel + 1,
        showModal: false,
        timer: 0,
      });
    } else {
      this.goToNextGame();
      // this.setState({
      //   currentLevel: 1,
      //   showModal: false,
      // });
      // this.props.history.push("/");
    }
  };

  goToNextGame = () => {
    GC.sendGameEndMessage();
    storage.destroy.all();
  };

  replayLevelMethod() {
    this.setState({
      showModal: false,
    });
    // TODO: Add Logic for resetting the level.
  }

  getSuccessModalThumbnail(level = 1) {
    return (
      <div className="shoveberry-modal__thumbnail-container">
        {level === SHOVEBERRY_LEVELS_DATA.length - 1 ? (
          <div className="shoveberry-modal__thumbnail-container--level-party"></div>
        ) : (
          <div className="shoveberry-modal__thumbnail-container--level-hexagon">
            {level}
          </div>
        )}
      </div>
    );
  }

  updateState = (key, state) => {
    if (key === "muteAudio") {
      this.setState({ muteAudio: !this.state.muteAudio });
      this.audio.volume = 0.4;
      this.state.muteAudio ? this.audio.play() : this.audio.pause();
    }
  };

  //update on clearing each level
  setLevelBasedScores = (obj) => {
    const pastScores = [...this.state.levelBasedScores];
    pastScores.push(obj);
    this.setState({
      levelBasedScores: pastScores,
    });
  };

  render() {
    const { showModal, showLevelModal, isMobileView, modalData, currentLevel } =
      this.state;

    return (
      <>
        <div className="shoveberry-level-layout">
          <div className="shoveberry-level-layout__header-container">
            {/* <ShoveberryLevelLayoutHeader
              onShowLevelModalClick={() =>
                this.setState({ showLevelModal: true })
              }
              showTimeOutModal={() => this.showTimeOutModal()}
            /> */}
            <Header
              muteAudio={this.state.muteAudio}
              onTimeFinish={() => this.showTimeOutModal()}
              updateState={this.updateState}
              updateTime={() => {}}
              level={currentLevel}
              totalLevels={SHOVEBERRY_LEVELS_DATA.length - 1}
            />
          </div>
          <div
            className="shoveberry-level-layout__main-container"
            style={{ height: this.getMainContainerHeight() }}
          >
            {/* <div className="shoveberry-level-layout__actions-panel-container desktop-only">
              <ShoveberryLevelLayoutActionsPanel
                handleReset={() => this.gridComponent.current.reset()}
                handleUndo={() => this.gridComponent.current.undoHandler()}
              />
            </div> */}
            <div className="shoveberry-level-layout__level-grid-container">
              <ShoveberryLevelGrid
                levelBasedScores={this.state.levelBasedScores}
                setLevelBasedScores={this.setLevelBasedScores}
                onLevelComplete={() => this.showSuccessModal()}
                currentLevel={currentLevel}
                board={SHOVEBERRY_LEVELS_DATA[currentLevel]}
                ref={this.gridComponent}
              />
            </div>
            <div className="shoveberry-level-layout__levels-list-container desktop-only">
              <ShoveberryLevelLayoutLevelsList
                currentLevel={currentLevel}
                totalLevels={SHOVEBERRY_LEVELS_DATA.length - 1}
                onClose={() => this.setState({ showLevelModal: false })}
              />
            </div>
          </div>
          <div className="shoveberry-level-layout__control-panel-container">
            <ShoveberryLevelsLayoutControlPanelResponsive
              showOnlyMoves={false}
              onUndo={() => this.gridComponent.current.undoHandler()}
              onReset={() => this.gridComponent.current.reset()}
              // onMusicClicked={() => {
              //   this.setState({ play: false })
              //   this.audio.pause()
              // }}
              onMoveUp={() =>
                this.gridComponent.current.keyPressEventHandler({ keyCode: 38 })
              }
              onMoveDown={() =>
                this.gridComponent.current.keyPressEventHandler({ keyCode: 40 })
              }
              onMoveLeft={() =>
                this.gridComponent.current.keyPressEventHandler({ keyCode: 37 })
              }
              onMoveRight={() =>
                this.gridComponent.current.keyPressEventHandler({ keyCode: 39 })
              }
            />
          </div>
        </div>
        {showModal && (
          <ShoveberryModal
            overlayColor={modalData.overlayColor}
            thumbnail={modalData.thumbnail}
            title={modalData.title}
            timeTaken={modalData.timeTaken}
            totalMoves={modalData.totalMoves}
            subTitle={modalData.subTitle}
            showPlayAgain={modalData.showPlayAgain}
            actionButtonText={modalData.actionButtonText}
            actionButtonRedirect={modalData.actionButtonRedirect}
            showTimeSection={modalData.showTimeSection}
            onSubmit={modalData.onSubmit}
          />
        )}
        {isMobileView && showLevelModal && (
          <ShoveberryLevelLayoutLevelsList
            currentLevel={currentLevel}
            totalLevels={SHOVEBERRY_LEVELS_DATA.length - 1}
            onClose={() => this.setState({ showLevelModal: false })}
          />
        )}
      </>
    );
  }
}
export default withRouter(ShoveBerryLevel);
